export const PUBLIC_LOCALE_STORAGE_KEY = "civicode.public.locale";

export const PUBLIC_LOCALES = ["en", "es"];

export const PUBLIC_LOCALE_LABELS = {
  en: "English",
  es: "Espanol",
};

export const PUBLIC_MESSAGES = {
  en: {
    shared: {
      signedOutTitle: "You’ve signed out.",
      signedOutMessage: "Sign in again whenever you’re ready.",
      switchLanguage: "Language",
      englishShort: "EN",
      spanishShort: "ES",
      backToHome: "Back to Home",
      signIn: "Sign In",
      createAccount: "Create Account",
      signInRequired: "Sign In Required",
      signInLoading: "Signing in...",
      createAccountLoading: "Creating Account...",
      loading: "Loading...",
      back: "Back",
      continue: "Continue",
      next: "Next",
      close: "Close",
      chooseFiles: "Choose files",
      addFiles: "Add files",
      noFilesSelected: "No files selected",
      clear: "Clear",
      remove: "Remove",
      oneFileSelected: "1 file selected",
      manyFilesSelected: "{count} files selected",
      searching: "Searching...",
      noDescriptionProvided: "No description was included with this submission.",
      addressUnavailable: "Address information unavailable",
      recently: "recently",
      unknown: "Unknown",
      notSet: "Not set",
      none: "None",
      requiredField: "This field is required.",
      emailPlaceholder: "you@example.com",
      phonePlaceholder: "(555) 555-5555",
      sealAlt: "{name} seal",
      skipToContent: "Skip to main content",
      opensInNewTab: "opens in new tab",
      showPassword: "Show password",
      hidePassword: "Hide password",
      fallBackOnly: "English fallback copy",
    },
    status: {
      application: {
        submitted: "Submitted",
        needs_more_info: "More information requested",
        under_review: "Compliance review",
        awaiting_inspection: "Awaiting inspection",
        inspection_scheduled: "Inspection scheduled",
        issues_found: "Issues to address",
        fees_due: "Fees due",
        payment_pending: "Payment requested",
        paid: "Paid",
        license_pending_approval: "Staff final review",
        denied: "Denied",
        license_issued: "License issued",
        pending: "Pending review",
        approved: "Approved",
        rejected: "Rejected",
        payment_sent: "Payment requested",
      },
      license: {
        Valid: "Valid",
        Unpaid: "Unpaid",
        Expired: "Expired",
        Revoked: "Revoked",
        onFile: "On file",
      },
      permitRequest: {
        Submitted: "Submitted",
        Scheduled: "Scheduled",
        Approved: "Approved",
        Issued: "Issued",
        Closed: "Closed",
      },
      permitApplication: {
        pending: "Pending review",
        under_review: "Under review",
        needs_more_info: "More information requested",
        approved: "Approved",
        rejected: "Not approved",
        cancelled: "Cancelled",
        withdrawn: "Withdrawn",
        closed: "Closed",
      },
      permitRequestSource: {
        default: "Permit request",
        Permit: "Permit request",
        Complaint: "Reported concern",
      },
      concern: {
        pending_review: "Pending review",
        violation_found: "Violation found",
        closed: "Closed",
      },
      permit: {
        expired: "Expired",
        paid: "Paid",
        payment_pending: "Payment pending",
      },
    },
    error: {
      common: {
        generic: "Something went wrong. Please try again.",
      },
      auth: {
        invalidCredentials: "The email or password you entered is incorrect.",
        sessionLoadFailed: "We could not finish signing you in. Please try again.",
        accountExists: "An account with that email already exists.",
        registrationFailed: "We could not create your account right now.",
        passwordMismatch: "Passwords do not match.",
        inactiveAccount: "This account is inactive. Contact an administrator.",
        tooManyAttempts: "Too many attempts. Please wait a moment and try again.",
        passwordTooShort: "Your password must be at least 8 characters long.",
      },
      publicDashboard: {
        load: "We could not load your public records right now.",
      },
      licenseApplication: {
        loadTypes: "Unable to load license options. Please try again later.",
      },
      residentConcern: {
        lookupValidation: "Enter a reference number and email or phone to search submitted concerns.",
        lookupFailed: "Unable to search submitted concerns right now.",
        submitFailed: "There was a problem submitting your concern. Please try again later.",
        contactSaveFailed: "We could not save the contact information. Please try again or select an existing contact.",
        duplicateContact: "That contact already exists. Please use the search option instead.",
        requiredContact: "Please select a suggested contact or provide a name plus an email or phone.",
      },
      permitRequest: {
        createUnit: "Unable to create suite / unit right now.",
      },
      payment: {
        notFound: "Payment request not found.",
        load: "Unable to load this payment request.",
        process: "Unable to process payment.",
      },
      myApplications: {
        load: "Could not load your applications. Please try again.",
      },
    },
    landing: {
      portalDescription: "Neighborhood Services & Online Licensing Portal",
      residentConcernsTitle: "Resident Concerns",
      residentConcernsBody:
        "Report code violations, neighborhood issues, or other municipal concerns. Submissions can be made anonymously. No account required.",
      residentConcernsAction: "Report a Concern",
      publicPortalTitle: "Public Portal",
      publicPortalBody:
        "Apply for business and residential licenses, track application status, receive feedback, make payments online, apply for permits, and submit and follow up on concerns.",
      publicPortalAction: "Open Public Portal",
      staffAccessTitle: "Staff Access",
      staffAccessBody:
        "Secure access for municipal staff and inspectors to manage cases, inspections, and license approvals.",
      staffAccessAction: "Municipal Staff Login",
      returnWebsite: "Return to main {name} website",
    },
    publicLogin: {
      title: "Public Login",
      description:
        "Sign in to apply for business and residential licenses, apply for permits, submit and follow up on concerns, receive feedback, and make payments online.",
      emailLabel: "Email Address",
      passwordLabel: "Password",
      passwordPlaceholder: "********",
      submit: "Sign In",
      registerCta: "Need an account? Register here",
      forgotPassword: "Forgot password?",
      staffLink: "Municipal Staff? Sign in here",
      lockoutTitle: "Too many failed login attempts",
      lockoutMessage: "You can wait 15 minutes before trying again, or",
      lockoutResetLink: "reset your password now",
      lockoutSuffix: "to regain access immediately.",
    },
    publicRegister: {
      title: "Create an Account",
      subtitle: "For residents and business owners.",
      nameLabel: "Full Name",
      namePlaceholder: "Jane Doe",
      emailLabel: "Email Address",
      phoneLabel: "Phone Number",
      passwordLabel: "Password",
      passwordPlaceholder: "Minimum 8 characters",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Repeat password",
      submit: "Create Account",
      existingAccount: "Already have an account? Sign in",
      successTitle: "Registration Successful!",
      successBody: "Redirecting you to the application...",
    },
    permitRequest: {
      authBody: "Please sign in or create an account to submit and track your permit requests.",
      heading: "Apply for a Permit",
      description:
        "Submit a building, dumpster, or POD permit request online. We will review the request, follow up if we need more information, and add the permit to your public portal activity once it is issued.",
      submitted: "Your permit request has been submitted.",
      reference: "Reference #{id}.",
      returnPortal: "Return to the public portal",
      formTitle: "Public Permit Request",
      formDescription: "Complete the steps below to submit a permit request.",
    },
    licenseApplication: {
      authBody: "Please sign in or create an account to submit and track your license applications.",
      heading: "Apply for a License",
      description: "Select the type of license you wish to apply for.",
      beginApplication: "Begin Application",
      noLicenses: "No licenses are currently available for application.",
      chooseDifferent: "Choose a different license",
      fee: "{amount} Fee",
    },
    contactSelection: {
      useMyInfo: "Use my info",
      useExisting: "Search existing contact",
      createNew: "Create a new contact",
      selectExisting: "Select an Existing Contact",
      searchExisting: "Type to search contacts by name or email...",
    },
    addressSearch: {
      help: "Enter the property's street address. It may be listed under a different property record.",
      placeholder: "Type to search addresses...",
      tooShort: "Type at least {count} characters of the street address.",
      noResults: "No matching address found. Try just the street number and street name, or enter it below.",
      failed: "We couldn't search addresses right now. Check your connection and try again, or enter the address below.",
      propertyRecord: "Property record: {address}",
      cantFind: "I can't find my address",
      hideManual: "Hide manual address",
      manualNote: "Staff will match this address during review.",
    },
    genericLicenseForm: {
      reviewSubmit: "Review & Submit",
      selectAddress: "Property Address",
      searchAddress: "Search by address...",
      selectBusiness: "Please select a business.",
      selectAddressError: "Please select an address.",
      businessToggleShow: "My business isn't listed — add it here",
      businessToggleHide: "− Hide",
      attachmentsLabel: "Attachments & Documents",
      contactLabel: "Contact",
      applicationSummary: "Application Summary",
      address: "Address",
      business: "Business",
      selectedBusiness: "Selected Business",
      contact: "Contact",
      loggedInUser: "Logged in User",
      additionalDetails: "Additional Details",
      applicationSubmittedTitle: "Application Submitted!",
      applicationSubmittedBody: "Your {name} application has been received.",
      applicationNumber: "Application #",
      applicationTracking:
        "You'll receive email updates as your application is reviewed by staff. You can track its status at any time from your dashboard.",
      trackApplication: "Track My Application",
      submitAnother: "Submit Another",
      step: "Step {current} of {total}: {label}",
      applicationHeading: "{name} Application",
      submit: "Submit Application",
    },
    newBuildingPermit: {
      steps: {
        attachments: "Attachments",
        address: "Address",
        contact: "Contact",
        review: "Review",
      },
      attachmentsLabel: "Plans, Application, or Photos",
      photoBankSelect: "Select from Photo Bank",
      photoBankCountOne: "1 photo from Photo Bank",
      photoBankCountMany: "{count} photos from Photo Bank",
      photoBankHeading: "Photos from Photo Bank:",
      uploadHelp: "Upload files or select from your Photo Bank, then continue to the next step.",
      addressLabel: "Select Address",
      searchAddress: "Type to search addresses...",
      assigneeLabel: "Assign to ONS member",
      assigneeDefault: "Unassigned (defaults to me)",
      contactLabel: "Contact (optional)",
      caseAssignment: "Case Assignment",
      createNewCase: "Create new case",
      caseTitlePlaceholder: "Case title (optional)",
      addExistingCase: "Add to existing case",
      selectCase: "Select a case...",
      reviewHeading: "Review and submit",
      reviewAddress: "Address",
      reviewAssignee: "Assignee",
      reviewContact: "Contact",
      reviewAttachments: "Attachments",
      notSelected: "Not selected",
      selectedUser: "Selected user",
      defaultsToMe: "Defaults to me",
      existingContact: "Existing contact #{id}",
      noAttachments: "No attachments",
      creating: "Creating...",
      submit: "Submit Permit",
    },
    residentConcern: {
      title: "Report a Concern",
      description:
        "Provide the property address, describe the issue, and include your contact information so we can follow up.",
      lookupTitle: "Find a submitted concern",
      lookupDescription:
        "Search by reference number plus your email or phone. Signed-in residents can also search using their account.",
      referenceNumber: "Reference number",
      referencePlaceholder: "e.g. 1234",
      emailLabel: "Email",
      phoneLabel: "Phone",
      signedInLookup:
        "You are signed in, so your account can be used to search your submitted concerns.",
      anonymousLookup:
        "If you submitted anonymously, use the same email or phone number you provided with the concern.",
      searchSubmitted: "Search submitted concerns",
      noMatches: "No submitted concerns matched those details.",
      useLookupLater: "Use the search panel below to look up this concern later.",
      submittedAt: "Submitted {value}",
      updatedAt: "Updated {value}",
      wholeProperty: "Whole property",
      noUnitsOnFile:
        "No units are currently on file for this property. Leave the concern on the whole property and include the unit in your description.",
      cantFindUnit: "If your unit is not listed, include it in the concern description.",
      descriptionLabel: "Describe the concern",
      descriptionHelp: "Include as many details as possible.",
      attachmentsLabel: "Attachments (optional)",
      attachmentsDescription: "Upload photos or documents that help describe the concern.",
      contactInfo: "Your contact information",
      usingContact: "Using this contact",
      enterDifferentContact: "Enter different contact details",
      submit: "Submit Concern",
      submitting: "Submitting...",
      successWithReference:
        "Thank you for submitting your concern. Your reference number is {id}.",
      successWithoutReference: "Thank you for submitting your concern.",
      addressLabel: "Address",
      addressPlaceholder: "Type to search for an address...",
      addressRequiredHelp: "Required before submitting.",
      noAddressToggle: "I can't find the address — let me describe the location instead",
      locationDescriptionLabel: "Describe the location",
      locationDescriptionPlaceholder: "e.g., alley behind the 400 block of Main St",
      locationDescriptionRequired: "Please describe the location of your concern.",
      unitLabel: "Suite / Unit (optional)",
      existingViolationsPropertyTitle: "Active violations already on this property",
      existingViolationsPropertyBodyOne:
        "This property already has 1 active violation.{suffix}",
      existingViolationsPropertyBodyMany:
        "This property already has {count} active violations.{suffix}",
      existingViolationsUnitTitle: "Active violations already on this suite / unit",
      existingViolationsUnitBodyOne: "Suite / Unit {unit} already has 1 active violation.",
      existingViolationsUnitBodyMany: "Suite / Unit {unit} already has {count} active violations.",
      existingViolationsElsewhereTitle: "Active violations exist elsewhere on this property",
      existingViolationsElsewhereBodyOne:
        "This suite / unit does not currently show active violations, but 1 active violation already exists elsewhere on the property.",
      existingViolationsElsewhereBodyMany:
        "This suite / unit does not currently show active violations, but {count} active violations already exist elsewhere on the property.",
      selectUnitSuffix: " Select a suite / unit for a more specific notice.",
      possibleContacts: "Possible existing contacts found",
      searchingContacts: "Searching contacts",
      matchSummaryFound: "These records match the details \"{value}\".",
      matchSummarySearching: "Looking for matches similar to \"{value}\"...",
      matchesOn: "Matches on {value}.",
      useThisContact: "Use this contact",
      searchingMatchingContacts: "Searching for matching contacts...",
      unitCreatedSelected: "Suite / Unit {unit} was added and selected.",
      unitAdded: "Suite / unit added.",
      unitAlreadyExists: "This suite / unit already exists.",
      unitSelected: "Selected suite / unit {unit}.",
      unitNumberRequired: "Enter a suite / unit number before creating it.",
      noDescriptionIncluded: "No description was included with this concern.",
      contactConsent:
        "By submitting, you agree to be contacted regarding this concern if additional information is needed.",
      honeypotLabel: "Do not fill this out if you are human",
      matchReason: {
        email: "email",
        phone: "phone",
        name: "name",
        and: "and",
      },
    },
    publicDashboard: {
      title: "Public portal{suffix}",
      description:
        "Apply for business and residential licenses, track application status, receive feedback, make payments online, apply for permits, and submit and follow up on concerns.",
      applyLicense: "Apply for license",
      applyPermit: "Apply for permit",
      submitConcern: "Submit concern",
      progress: {
        title: "Application progress",
        current: "Current status",
        next: "Next step",
        licenseAria: "Application #{id} progress",
        permitAria: "Permit application #{id} progress",
        permitActions: {
          awaitingReview: "No action is needed from you while staff reviews the application.",
          preparingPermit: "Your application is approved. Staff is preparing the permit.",
          payment: "Your application is approved. Pay the permit fee using the instructions in your messages.",
          inspection: "Payment received. A Town inspector will inspect the property.",
          issuesFound: "The inspection found issues. Check your messages for what needs to change.",
          sending: "Your permit has been issued. Staff will email it to you shortly.",
          complete: "Your permit has been issued and sent to you.",
          notApproved: "This application was not approved. Contact the municipality if you have questions.",
        },
      },
      summary: {
        applications: "Applications",
        licenses: "Licenses",
        licensesAndApplications: "Licenses & applications",
        permits: "Permits",
        permitRequests: "Permit Requests",
        issuedPermits: "Issued Permits",
        concerns: "Concerns",
        awaitingReviewOne: "1 awaiting review",
        awaitingReviewMany: "{count} awaiting review",
        noApplicationsAwaiting: "No applications awaiting review",
        activeOrUnpaidOne: "1 active or unpaid",
        activeOrUnpaidMany: "{count} active or unpaid",
        noLicenseRecords: "No license records on file",
        applicationInProgressOne: "1 application in progress",
        applicationInProgressMany: "{count} applications in progress",
        noLicenseActivity: "No licenses or applications on file",
        inProgressOne: "1 still in progress",
        inProgressMany: "{count} still in progress",
        noOpenPermitRequests: "No open permit requests",
        unpaidPermitsOne: "1 still needs payment",
        unpaidPermitsMany: "{count} still need payment",
        allPermitsCurrent: "All listed permits are paid or current",
        activeConcernsOne: "1 still in progress",
        activeConcernsMany: "{count} still in progress",
        noActiveConcerns: "No active concerns right now",
      },
      sections: {
        licenseRecords: "License records",
        licenseRecordsDescription:
          "Your license applications and issued licenses, including current status and expiration dates.",
        permitTracker: "Permit request tracker",
        permitTrackerDescription:
          "Requests you have submitted, including whether they have been scheduled, approved, or issued.",
        issuedPermits: "Issued permits",
        issuedPermitsDescription:
          "Recent permits associated with your account, including issue dates and payment status.",
        concernTracker: "Concern tracker",
        concernTrackerDescription:
          "Reference numbers and current status for the concerns you have submitted.",
        applicationTracker: "License application tracker",
        applicationTrackerDescription:
          "Your current municipal license applications and any staff updates tied to them.",
      },
      empty: {
        noIssuedLicenses: "No issued licenses yet",
        noIssuedLicensesBody:
          "When a license is issued and linked to your account, it will appear here with its current status and expiration date.",
        noPermitRequests: "No permit requests yet",
        noPermitRequestsBody:
          "Submit a permit request online and it will appear here with its current review status.",
        noPermits: "No permits yet",
        noPermitsBody:
          "When a permit connected to your account is created, it will appear here with payment and expiration details.",
        noConcerns: "No concerns submitted",
        noConcernsBody:
          "If you need to report a property issue, missed collection, or other neighborhood concern, you can submit it online here.",
        noApplications: "No applications on file",
        noApplicationsBody:
          "Submit a municipal license application online and it will appear here for status tracking and payment follow-up.",
      },
      labels: {
        license: "License #{id}",
        request: "Request #{id}",
        permit: "Permit #{id}",
        reference: "Reference #{id}",
        application: "Application #{id}",
        permitApplication: "Permit application #{id}",
        permitApplicationFields: {
          permit_type: "Permit type",
          contact_name: "Applicant name",
          email: "Email",
          phone: "Phone",
        },
        municipalLicenseApplication: "Municipal license application",
        submittedLabel: "Submitted",
        type: "Type",
        fiscalYear: "Fiscal year",
        issued: "Issued",
        expires: "Expires",
        recordCreated: "Record created",
        submitted: "Submitted {value}",
        lastUpdated: "Last updated {value}",
        noRequestDescription: "No request description was included with this submission.",
        issuedAsPermit: "Issued as permit {permit}.{suffix}",
        startApplication: "Start application",
        startPermitRequest: "Start permit request",
        reportConcern: "Report a concern",
        noExpirationDate: "No expiration date",
        notIssuedYet: "Not issued yet",
        municipalPermit: "Municipal permit",
        pending: "pending",
      },
    },
    myApplications: {
      title: "My Applications",
      description: "Track the status of your municipal license applications.",
      newApplication: "New Application",
      emptyTitle: "No Applications Yet",
      emptyBody:
        "When you submit a license application, it will appear here so you can track its progress.",
      startFirst: "Start your first application",
      submittedOn: "Submitted on {value}",
      inspectionScheduledFor: "Inspection scheduled for {value}",
      messageFromStaff: "Message from Staff",
      fee: "Fee",
      applicant: "Applicant",
      currentStatus: "Current status",
      nextAction: "Next action",
      lastUpdate: "Last Update",
      workflow: {
        states: {
          awaitingReview: "Awaiting staff review.",
          underReview: "Staff is reviewing your application.",
          revisionRequired: "Changes are required before review can continue.",
          denied: "This application was denied and is closed to edits and resubmission.",
          billingPreparation: "Review complete — billing is being prepared.",
          paymentDue: "Payment is due.",
          awaitingInspection: "Payment received — awaiting inspection scheduling.",
          inspectionScheduled: "Your inspection is scheduled.",
          inspectionInProgress: "Your inspection is in progress.",
          inspectionUnderReview: "Your inspection results are under review.",
          inspectionIssues: "The inspection found issues that must be resolved.",
          awaitingLicense: "Requirements complete — staff is completing final review.",
          awaitingDelivery: "Your license is awaiting staff final approval.",
          complete: "Your license is approved and available to download.",
        },
        actions: {
          none: "No action is needed from you right now.",
          reviseAndResubmit: "Review the staff instructions, update your application, and resubmit it.",
          contactOffice: "Review the decision and contact our office if you have questions.",
          submitPayment: "Open your invoice and submit payment.",
          prepareForInspection: "Be ready at the scheduled time and follow any instructions from staff.",
          reviewInspectionInstructions: "Review the inspection findings and follow the instructions from staff.",
          downloadLicense: "Open your license record to download a copy. Email delivery is optional.",
        },
      },
      activities: {
        reviewed: "Reviewed {value}",
        paymentRequested: "Payment requested {value}",
        paymentReceived: "Payment received {value}",
        inspectionScheduled: "Inspection scheduled {value}",
      },
      additionalDetails: "Additional Details",
      showAllDetails: "Show all details",
      hideAllDetails: "Hide extra details",
      detailGroups: {
        applicant: "Applicant",
        business: "Business",
        property: "Property & ownership",
        owners: "Business owners",
        contacts: "Contacts",
        fees: "Fees",
        attestations: "Signature & attestation",
        other: "Other details",
      },
      quickbooksInvoiceIssued: "QuickBooks invoice {value}",
      quickbooksInvoiceIssuedFallback: "QuickBooks invoice issued",
      viewInvoice: "View Invoice / Payment Status",
      proceedToPayment: "Proceed to Payment",
      openInvoice: "Open QuickBooks Invoice",
      viewPaymentInstructions: "View Payment Instructions",
      awaitInvoice: "Review Payment Status",
      quickbooksPaymentHelp: "Open your QuickBooks invoice to pay. Staff will mark this application paid after payment is received.",
      quickbooksPaymentPendingHelp:
        "Staff will send your QuickBooks invoice link through your application messages once it is ready.",
      openLicense: "Open and download license",
      downloadConditionalLicense: "Download conditional license",
      preparingDownload: "Preparing download...",
    },
    payment: {
      title: "Application Payment Instructions",
      quickbooksDescription: "Use the QuickBooks invoice for payment and return here to check the status.",
      standardDescription: "Staff will send a QuickBooks invoice link for this application.",
      refreshSuccess: "Payment status refreshed.",
      paymentRecorded: "Payment recorded successfully.",
      application: "Application",
      status: "Status",
      licenseType: "License Type",
      amountDue: "Amount Due",
      applicant: "Applicant",
      submitted: "Submitted",
      quickbooksInvoice: "QuickBooks Invoice",
      quickbooksSync: "QuickBooks Sync",
      issued: "Issued",
      pending: "Pending",
      alreadyPaid: "This application was already marked paid on {value}.",
      quickbooksBody:
        "This invoice is managed through QuickBooks Online. Use the QuickBooks invoice link from staff to complete payment.",
      quickbooksStepOne: "1. Open the QuickBooks invoice link provided by staff.",
      quickbooksStepTwo: "2. Complete payment through QuickBooks Online.",
      quickbooksStepThree: "3. Staff will mark your application paid in CodeSoft after payment is received.",
      quickbooksLinkPending:
        "Your application is waiting on a QuickBooks invoice link. Check your application messages or contact staff if you do not see one yet.",
      invoicePendingBody:
        "Payment for this application is handled through a staff-issued QuickBooks invoice. Check your application messages for the invoice link. Staff will mark the application paid after payment is received.",
      openQuickbooksInvoice: "Open QuickBooks Invoice",
      refreshPaymentStatus: "Refresh Payment Status",
      refreshingPaymentStatus: "Refreshing...",
      confirmPayment: "Confirm Payment",
      processingPayment: "Processing payment...",
      returnPortal: "Return to Public Portal",
    },
    helpWidget: {
      openLabel: "Help and questions",
      title: "Help Center",
      subtitle: "Ask a question or message town staff.",
      tabAssistant: "Ask a question",
      tabStaff: "Contact staff",
      assistantGreeting:
        "Hi! I can help with permits, licenses, town code rules, and finding your way around this portal. What would you like to know?",
      assistantDisclaimer: "AI-generated guidance, not legal advice. Town staff decisions are final.",
      assistantPlaceholder: "Ask about permits, licenses, town code...",
      assistantSend: "Send message",
      assistantThinking: "Thinking...",
      newConversation: "New conversation",
      wasHelpful: "Was this helpful?",
      talkToStaff: "Talk to staff instead",
      feedbackThanks: "Thanks for the feedback!",
      errorDisabled: "The assistant is currently unavailable. Please contact staff instead.",
      errorRateLimit: "You're sending messages too quickly. Please wait a few minutes and try again.",
      errorTimeout: "The assistant took too long to reply. Please try again.",
      errorGeneric: "Sorry, something went wrong. Please try again in a moment.",
      turnstileHint: "Please complete the quick verification below to start chatting.",
      anonStaffIntro: "To message town staff directly and track your applications, sign in or create a free account.",
      anonConcernHint: "Reporting a property issue? You don't need an account:",
      anonConcernLink: "Report a concern",
      anonSignIn: "Sign in",
      anonRegister: "Create account",
      loadingOptions: "Loading help options...",
      choicePrompt: "Is this message about one of your applications?",
      chooseApplication: "Yes, choose an application",
      generalHelp: "No, I need general help",
      selectApplication: "Select the application",
      messageLabel: "Your message",
      describeHelpPlaceholder: "Describe what you need help with...",
      sendToApplicationStaff: "Send to application staff",
      sending: "Sending...",
      generalPrompt: "What do you need help with?",
      generalPlaceholder: "Describe the issue. Staff will see which portal page you were on.",
      sendHelpRequest: "Send help request",
      viewRecentThread: "View your recent support thread",
      startThreadIntro: "Start a general support request and staff will respond here.",
      startRequest: "Start request",
      noMessages: "No messages yet.",
      replyPlaceholder: "Type your reply...",
      sendReply: "Send reply",
      you: "You",
      staff: "Staff",
      messageSent: "Your message was sent to staff on that application.",
      requestSent: "Your request was sent to staff.",
      errorLoad: "Unable to load help options.",
      errorSendMessage: "Unable to send your message.",
      errorSendRequest: "Unable to send your request.",
      errorSendReply: "Unable to send your reply.",
    },
    pageTitles: {
      landing: "Home",
      residentConcern: "Report a Concern",
      applyLicense: "Business License Application",
      applyPermit: "Permit Application",
      payment: "Application Payment",
      verifyLicense: "Verify a License",
      publicLogin: "Resident Sign In",
      register: "Create an Account",
      staffLogin: "Staff Sign In",
      forgotPassword: "Forgot Password",
      resetPassword: "Reset Password",
      myApplications: "My Applications",
      publicDashboard: "Resident Dashboard",
    },
  },
  es: {
    shared: {
      signedOutTitle: "Has cerrado sesión.",
      signedOutMessage: "Vuelve a iniciar sesión cuando quieras.",
      fallBackOnly: "Texto alternativo en ingles",
      switchLanguage: "Idioma",
      englishShort: "EN",
      spanishShort: "ES",
      backToHome: "Volver al inicio",
      signIn: "Iniciar sesion",
      createAccount: "Crear cuenta",
      signInRequired: "Se requiere iniciar sesion",
      signInLoading: "Iniciando sesion...",
      createAccountLoading: "Creando cuenta...",
      loading: "Cargando...",
      back: "Atras",
      continue: "Continuar",
      next: "Siguiente",
      close: "Cerrar",
      chooseFiles: "Elegir archivos",
      addFiles: "Agregar archivos",
      noFilesSelected: "No hay archivos seleccionados",
      clear: "Borrar",
      remove: "Quitar",
      oneFileSelected: "1 archivo seleccionado",
      manyFilesSelected: "{count} archivos seleccionados",
      searching: "Buscando...",
      noDescriptionProvided: "No se incluyo una descripcion con este envio.",
      addressUnavailable: "Informacion de direccion no disponible",
      recently: "recientemente",
      unknown: "Desconocido",
      notSet: "Sin definir",
      none: "Ninguno",
      requiredField: "Este campo es obligatorio.",
      emailPlaceholder: "usted@ejemplo.com",
      phonePlaceholder: "(555) 555-5555",
      sealAlt: "Sello de {name}",
      skipToContent: "Saltar al contenido principal",
      opensInNewTab: "se abre en una pestana nueva",
      showPassword: "Mostrar contrasena",
      hidePassword: "Ocultar contrasena",
    },
    status: {
      application: {
        submitted: "Enviada",
        needs_more_info: "Se solicita mas informacion",
        under_review: "Revision de cumplimiento",
        awaiting_inspection: "En espera de inspeccion",
        inspection_scheduled: "Inspeccion programada",
        issues_found: "Problemas por corregir",
        fees_due: "Pago adeudado",
        payment_pending: "Pago solicitado",
        paid: "Pagada",
        license_pending_approval: "Revision final del personal",
        denied: "Denegada",
        license_issued: "Licencia emitida",
        pending: "Pendiente de revision",
        approved: "Aprobada",
        rejected: "Rechazada",
        payment_sent: "Pago solicitado",
      },
      license: {
        Valid: "Vigente",
        Unpaid: "Sin pagar",
        Expired: "Vencida",
        Revoked: "Revocada",
        onFile: "Registrada",
      },
      permitRequest: {
        Submitted: "Enviada",
        Scheduled: "Programada",
        Approved: "Aprobada",
        Issued: "Emitida",
        Closed: "Cerrada",
      },
      permitApplication: {
        pending: "Pendiente de revision",
        under_review: "En revision",
        needs_more_info: "Se solicito mas informacion",
        approved: "Aprobada",
        rejected: "No aprobada",
        cancelled: "Cancelada",
        withdrawn: "Retirada",
        closed: "Cerrada",
      },
      permitRequestSource: {
        default: "Solicitud de permiso",
        Permit: "Solicitud de permiso",
        Complaint: "Inquietud reportada",
      },
      concern: {
        pending_review: "Pendiente de revision",
        violation_found: "Se encontro una infraccion",
        closed: "Cerrada",
      },
      permit: {
        expired: "Vencido",
        paid: "Pagado",
        payment_pending: "Pago pendiente",
      },
    },
    error: {
      common: {
        generic: "Ocurrio un error. Intente nuevamente.",
      },
      auth: {
        invalidCredentials: "El correo electronico o la contrasena es incorrecto.",
        sessionLoadFailed: "No pudimos completar el inicio de sesion. Intente de nuevo.",
        accountExists: "Ya existe una cuenta con ese correo electronico.",
        registrationFailed: "No pudimos crear su cuenta en este momento.",
        passwordMismatch: "Las contrasenas no coinciden.",
        inactiveAccount: "Esta cuenta esta inactiva. Comuniquese con un administrador.",
        tooManyAttempts: "Demasiados intentos. Espere un momento e intente nuevamente.",
        passwordTooShort: "Su contrasena debe tener al menos 8 caracteres.",
      },
      publicDashboard: {
        load: "No pudimos cargar sus registros publicos en este momento.",
      },
      licenseApplication: {
        loadTypes: "No se pudieron cargar las opciones de licencia. Intente nuevamente mas tarde.",
      },
      residentConcern: {
        lookupValidation:
          "Ingrese un numero de referencia y un correo electronico o telefono para buscar reportes enviados.",
        lookupFailed: "No se pudieron buscar los reportes enviados en este momento.",
        submitFailed: "Hubo un problema al enviar su reporte. Intente nuevamente mas tarde.",
        contactSaveFailed:
          "No pudimos guardar la informacion de contacto. Intente nuevamente o seleccione un contacto existente.",
        duplicateContact: "Ese contacto ya existe. Use la opcion de busqueda.",
        requiredContact:
          "Seleccione un contacto sugerido o proporcione un nombre y un correo electronico o telefono.",
      },
      permitRequest: {
        createUnit: "No se puede crear la suite / unidad en este momento.",
      },
      payment: {
        notFound: "No se encontro la solicitud de pago.",
        load: "No se pudo cargar esta solicitud de pago.",
        process: "No se pudo procesar el pago.",
      },
      myApplications: {
        load: "No se pudieron cargar sus solicitudes. Intente nuevamente.",
      },
    },
    landing: {
      portalDescription: "Portal en linea de servicios vecinales y licencias",
      residentConcernsTitle: "Reportes vecinales",
      residentConcernsBody:
        "Reporte infracciones del codigo, problemas del vecindario u otras preocupaciones municipales. Los envios pueden hacerse de forma anonima. No se requiere cuenta.",
      residentConcernsAction: "Reportar un problema",
      publicPortalTitle: "Portal publico",
      publicPortalBody:
        "Solicite licencias comerciales y residenciales, revise el estado de sus solicitudes, reciba comentarios, haga pagos en linea, solicite permisos y presente y consulte reportes.",
      publicPortalAction: "Abrir portal publico",
      staffAccessTitle: "Acceso del personal",
      staffAccessBody:
        "Acceso seguro para personal municipal e inspectores para administrar casos, inspecciones y aprobaciones de licencias.",
      staffAccessAction: "Ingreso del personal municipal",
      returnWebsite: "Volver al sitio principal de {name}",
    },
    publicLogin: {
      title: "Ingreso publico",
      description:
        "Inicie sesion para solicitar licencias comerciales y residenciales, solicitar permisos, presentar y consultar reportes, recibir comentarios y hacer pagos en linea.",
      emailLabel: "Correo electronico",
      passwordLabel: "Contrasena",
      passwordPlaceholder: "********",
      submit: "Iniciar sesion",
      registerCta: "Necesita una cuenta? Registrese aqui",
      forgotPassword: "Olvido su contrasena?",
      staffLink: "Personal municipal? Ingrese aqui",
      lockoutTitle: "Demasiados intentos fallidos de inicio de sesion",
      lockoutMessage: "Puede esperar 15 minutos antes de intentar de nuevo, o",
      lockoutResetLink: "restablecer su contrasena ahora",
      lockoutSuffix: "para recuperar el acceso de inmediato.",
    },
    publicRegister: {
      title: "Crear una cuenta",
      subtitle: "Para residentes y propietarios de negocios.",
      nameLabel: "Nombre completo",
      namePlaceholder: "Ana Perez",
      emailLabel: "Correo electronico",
      phoneLabel: "Numero de telefono",
      passwordLabel: "Contrasena",
      passwordPlaceholder: "Minimo 8 caracteres",
      confirmPasswordLabel: "Confirmar contrasena",
      confirmPasswordPlaceholder: "Repita la contrasena",
      submit: "Crear cuenta",
      existingAccount: "Ya tiene una cuenta? Inicie sesion",
      successTitle: "Registro exitoso!",
      successBody: "Redirigiendole a la solicitud...",
    },
    permitRequest: {
      authBody: "Inicie sesion o cree una cuenta para enviar y seguir sus solicitudes de permiso.",
      heading: "Solicitar un permiso",
      description:
        "Envíe en linea una solicitud de permiso de construccion, contenedor o POD. Revisaremos la solicitud, nos comunicaremos si necesitamos mas informacion y agregaremos el permiso a su actividad del portal publico cuando sea emitido.",
      submitted: "Su solicitud de permiso fue enviada.",
      reference: "Referencia #{id}.",
      returnPortal: "Volver al portal publico",
      formTitle: "Solicitud publica de permiso",
      formDescription: "Complete los pasos a continuacion para enviar una solicitud de permiso.",
    },
    licenseApplication: {
      authBody: "Inicie sesion o cree una cuenta para enviar y seguir sus solicitudes de licencia.",
      heading: "Solicitar una licencia",
      description: "Seleccione el tipo de licencia que desea solicitar.",
      beginApplication: "Comenzar solicitud",
      noLicenses: "No hay licencias disponibles para solicitar en este momento.",
      chooseDifferent: "Elegir una licencia diferente",
      fee: "Cargo de {amount}",
    },
    contactSelection: {
      useMyInfo: "Usar mi información",
      useExisting: "Buscar contacto existente",
      createNew: "Crear un contacto nuevo",
      selectExisting: "Seleccionar un contacto existente",
      searchExisting: "Escriba para buscar contactos por nombre o correo electronico...",
    },
    addressSearch: {
      help: "Escriba la direccion de la propiedad. Puede figurar bajo otro registro de propiedad.",
      placeholder: "Escriba para buscar direcciones...",
      tooShort: "Escriba al menos {count} caracteres de la direccion.",
      noResults: "No se encontro ninguna direccion. Pruebe solo con el numero y el nombre de la calle, o escribala abajo.",
      failed: "No pudimos buscar direcciones en este momento. Revise su conexion e intente de nuevo, o escriba la direccion abajo.",
      propertyRecord: "Registro de la propiedad: {address}",
      cantFind: "No encuentro mi direccion",
      hideManual: "Ocultar direccion manual",
      manualNote: "El personal verificara esta direccion durante la revision.",
    },
    genericLicenseForm: {
      reviewSubmit: "Revisar y enviar",
      selectAddress: "Direccion de la propiedad",
      searchAddress: "Buscar por direccion...",
      selectBusiness: "Seleccione un negocio.",
      selectAddressError: "Seleccione una direccion.",
      businessToggleShow: "Mi negocio no aparece — agregarlo aquí",
      businessToggleHide: "− Ocultar",
      attachmentsLabel: "Archivos y documentos",
      contactLabel: "Contacto",
      applicationSummary: "Resumen de la solicitud",
      address: "Direccion",
      business: "Negocio",
      selectedBusiness: "Negocio seleccionado",
      contact: "Contacto",
      loggedInUser: "Usuario conectado",
      additionalDetails: "Detalles adicionales",
      applicationSubmittedTitle: "Solicitud enviada!",
      applicationSubmittedBody: "Hemos recibido su solicitud de {name}.",
      applicationNumber: "Solicitud #",
      applicationTracking:
        "Recibira actualizaciones por correo electronico mientras el personal revisa su solicitud. Puede consultar su estado en cualquier momento desde su panel.",
      trackApplication: "Ver mi solicitud",
      submitAnother: "Enviar otra",
      step: "Paso {current} de {total}: {label}",
      applicationHeading: "Solicitud de {name}",
      submit: "Enviar solicitud",
    },
    newBuildingPermit: {
      steps: {
        attachments: "Archivos",
        address: "Direccion",
        contact: "Contacto",
        review: "Revision",
      },
      attachmentsLabel: "Planos, solicitud o fotos",
      photoBankSelect: "Seleccionar del banco de fotos",
      photoBankCountOne: "1 foto del banco de fotos",
      photoBankCountMany: "{count} fotos del banco de fotos",
      photoBankHeading: "Fotos del banco de fotos:",
      uploadHelp: "Suba archivos o seleccione fotos de su banco de fotos y luego continue al siguiente paso.",
      addressLabel: "Seleccionar direccion",
      searchAddress: "Escriba para buscar direcciones...",
      assigneeLabel: "Asignar a un miembro de ONS",
      assigneeDefault: "Sin asignar (por defecto a mi)",
      contactLabel: "Contacto (opcional)",
      caseAssignment: "Asignacion de caso",
      createNewCase: "Crear caso nuevo",
      caseTitlePlaceholder: "Titulo del caso (opcional)",
      addExistingCase: "Agregar a un caso existente",
      selectCase: "Seleccione un caso...",
      reviewHeading: "Revisar y enviar",
      reviewAddress: "Direccion",
      reviewAssignee: "Asignado a",
      reviewContact: "Contacto",
      reviewAttachments: "Archivos",
      notSelected: "No seleccionado",
      selectedUser: "Usuario seleccionado",
      defaultsToMe: "Por defecto a mi",
      existingContact: "Contacto existente #{id}",
      noAttachments: "Sin archivos adjuntos",
      creating: "Creando...",
      submit: "Enviar permiso",
    },
    residentConcern: {
      title: "Reportar un problema",
      description:
        "Proporcione la direccion de la propiedad, describa el problema e incluya su informacion de contacto para que podamos dar seguimiento.",
      lookupTitle: "Buscar un reporte enviado",
      lookupDescription:
        "Busque por numero de referencia y su correo electronico o telefono. Los residentes que hayan iniciado sesion tambien pueden buscar con su cuenta.",
      referenceNumber: "Numero de referencia",
      referencePlaceholder: "por ejemplo, 1234",
      emailLabel: "Correo electronico",
      phoneLabel: "Telefono",
      signedInLookup:
        "Ha iniciado sesion, por lo que su cuenta se puede usar para buscar sus reportes enviados.",
      anonymousLookup:
        "Si envio el reporte de forma anonima, use el mismo correo electronico o telefono que proporciono con el reporte.",
      searchSubmitted: "Buscar reportes enviados",
      noMatches: "Ningun reporte enviado coincide con esos datos.",
      useLookupLater: "Use el panel de busqueda de abajo para consultar este reporte despues.",
      submittedAt: "Enviado {value}",
      updatedAt: "Actualizado {value}",
      wholeProperty: "Toda la propiedad",
      noUnitsOnFile:
        "No hay unidades registradas actualmente para esta propiedad. Deje el reporte sobre toda la propiedad e incluya la unidad en la descripcion.",
      cantFindUnit: "Si su unidad no aparece, incluyala en la descripcion del reporte.",
      descriptionLabel: "Describa el problema",
      descriptionHelp: "Incluya la mayor cantidad de detalles posible.",
      attachmentsLabel: "Archivos adjuntos (opcional)",
      attachmentsDescription: "Suba fotos o documentos que ayuden a describir el problema.",
      contactInfo: "Su informacion de contacto",
      usingContact: "Usando este contacto",
      enterDifferentContact: "Ingresar datos de contacto diferentes",
      submit: "Enviar reporte",
      submitting: "Enviando...",
      successWithReference:
        "Gracias por enviar su reporte. Su numero de referencia es {id}.",
      successWithoutReference: "Gracias por enviar su reporte.",
      addressLabel: "Direccion",
      addressPlaceholder: "Escriba para buscar una direccion...",
      addressRequiredHelp: "Obligatorio antes de enviar.",
      noAddressToggle: "No encuentro la direccion — dejeme describir la ubicacion",
      locationDescriptionLabel: "Describa la ubicacion",
      locationDescriptionPlaceholder: "p. ej., el callejon detras de la cuadra 400 de Main St",
      locationDescriptionRequired: "Por favor describa la ubicacion de su reporte.",
      unitLabel: "Suite / Unidad (opcional)",
      existingViolationsPropertyTitle: "Ya existen infracciones activas en esta propiedad",
      existingViolationsPropertyBodyOne:
        "Esta propiedad ya tiene 1 infraccion activa.{suffix}",
      existingViolationsPropertyBodyMany:
        "Esta propiedad ya tiene {count} infracciones activas.{suffix}",
      existingViolationsUnitTitle: "Ya existen infracciones activas en esta suite / unidad",
      existingViolationsUnitBodyOne: "La suite / unidad {unit} ya tiene 1 infraccion activa.",
      existingViolationsUnitBodyMany: "La suite / unidad {unit} ya tiene {count} infracciones activas.",
      existingViolationsElsewhereTitle: "Existen infracciones activas en otra parte de esta propiedad",
      existingViolationsElsewhereBodyOne:
        "Esta suite / unidad no muestra infracciones activas en este momento, pero ya existe 1 infraccion activa en otra parte de la propiedad.",
      existingViolationsElsewhereBodyMany:
        "Esta suite / unidad no muestra infracciones activas en este momento, pero ya existen {count} infracciones activas en otra parte de la propiedad.",
      selectUnitSuffix: " Seleccione una suite / unidad para ver un aviso mas especifico.",
      possibleContacts: "Se encontraron posibles contactos existentes",
      searchingContacts: "Buscando contactos",
      matchSummaryFound: "Estos registros coinciden con los datos \"{value}\".",
      matchSummarySearching: "Buscando coincidencias similares a \"{value}\"...",
      matchesOn: "Coincide por {value}.",
      useThisContact: "Usar este contacto",
      searchingMatchingContacts: "Buscando contactos coincidentes...",
      unitCreatedSelected: "La suite / unidad {unit} fue agregada y seleccionada.",
      unitAdded: "Suite / unidad agregada.",
      unitAlreadyExists: "Esta suite / unidad ya existe.",
      unitSelected: "Se selecciono la suite / unidad {unit}.",
      unitNumberRequired: "Ingrese un numero de suite / unidad antes de crearla.",
      noDescriptionIncluded: "No se incluyo una descripcion con este reporte.",
      contactConsent:
        "Al enviar este reporte, usted acepta que podamos comunicarnos con usted si necesitamos informacion adicional.",
      honeypotLabel: "No complete este campo si es una persona",
      matchReason: {
        email: "correo electronico",
        phone: "telefono",
        name: "nombre",
        and: "y",
      },
    },
    publicDashboard: {
      title: "Portal publico{suffix}",
      description:
        "Solicite licencias comerciales y residenciales, consulte el estado de sus solicitudes, reciba comentarios, haga pagos en linea, solicite permisos y presente y consulte reportes.",
      applyLicense: "Solicitar licencia",
      applyPermit: "Solicitar permiso",
      submitConcern: "Enviar reporte",
      progress: {
        title: "Progreso de la solicitud",
        current: "Estado actual",
        next: "Siguiente paso",
        licenseAria: "Progreso de la solicitud #{id}",
        permitAria: "Progreso de la solicitud de permiso #{id}",
        permitActions: {
          awaitingReview: "No necesita hacer nada mientras el personal revisa la solicitud.",
          preparingPermit: "Su solicitud fue aprobada. El personal esta preparando el permiso.",
          payment: "Su solicitud fue aprobada. Pague la tarifa del permiso siguiendo las instrucciones en sus mensajes.",
          inspection: "Pago recibido. Un inspector del municipio inspeccionara la propiedad.",
          issuesFound: "La inspeccion encontro problemas. Revise sus mensajes para saber que debe cambiar.",
          sending: "Su permiso fue emitido. El personal se lo enviara por correo electronico pronto.",
          complete: "Su permiso fue emitido y enviado.",
          notApproved: "Esta solicitud no fue aprobada. Comuniquese con el municipio si tiene preguntas.",
        },
      },
      summary: {
        applications: "Solicitudes",
        licenses: "Licencias",
        licensesAndApplications: "Licencias y solicitudes",
        permits: "Permisos",
        permitRequests: "Solicitudes de permiso",
        issuedPermits: "Permisos emitidos",
        concerns: "Reportes",
        awaitingReviewOne: "1 pendiente de revision",
        awaitingReviewMany: "{count} pendientes de revision",
        noApplicationsAwaiting: "No hay solicitudes pendientes de revision",
        activeOrUnpaidOne: "1 activa o sin pagar",
        activeOrUnpaidMany: "{count} activas o sin pagar",
        noLicenseRecords: "No hay licencias registradas",
        applicationInProgressOne: "1 solicitud en proceso",
        applicationInProgressMany: "{count} solicitudes en proceso",
        noLicenseActivity: "No hay licencias ni solicitudes registradas",
        inProgressOne: "1 todavia en proceso",
        inProgressMany: "{count} todavia en proceso",
        noOpenPermitRequests: "No hay solicitudes de permiso abiertas",
        unpaidPermitsOne: "1 aun necesita pago",
        unpaidPermitsMany: "{count} aun necesitan pago",
        allPermitsCurrent: "Todos los permisos listados estan pagados o vigentes",
        activeConcernsOne: "1 todavia en proceso",
        activeConcernsMany: "{count} todavia en proceso",
        noActiveConcerns: "No hay reportes activos en este momento",
      },
      sections: {
        licenseRecords: "Registros de licencias",
        licenseRecordsDescription:
          "Sus solicitudes de licencia y licencias emitidas, incluido su estado actual y fechas de vencimiento.",
        permitTracker: "Seguimiento de solicitudes de permiso",
        permitTrackerDescription:
          "Solicitudes que ha presentado, incluido si han sido programadas, aprobadas o emitidas.",
        issuedPermits: "Permisos emitidos",
        issuedPermitsDescription:
          "Permisos recientes asociados a su cuenta, incluidas fechas de emision y estado del pago.",
        concernTracker: "Seguimiento de reportes",
        concernTrackerDescription:
          "Numeros de referencia y estado actual de los reportes que ha presentado.",
        applicationTracker: "Seguimiento de solicitudes de licencia",
        applicationTrackerDescription:
          "Sus solicitudes municipales de licencia actuales y cualquier actualizacion del personal asociada a ellas.",
      },
      empty: {
        noIssuedLicenses: "Todavia no hay licencias emitidas",
        noIssuedLicensesBody:
          "Cuando se emita una licencia vinculada a su cuenta, aparecera aqui con su estado actual y fecha de vencimiento.",
        noPermitRequests: "Todavia no hay solicitudes de permiso",
        noPermitRequestsBody:
          "Envíe una solicitud de permiso en linea y aparecera aqui con su estado actual de revision.",
        noPermits: "Todavia no hay permisos",
        noPermitsBody:
          "Cuando se cree un permiso vinculado a su cuenta, aparecera aqui con sus detalles de pago y vencimiento.",
        noConcerns: "No hay reportes enviados",
        noConcernsBody:
          "Si necesita reportar un problema de propiedad, una recoleccion perdida u otra preocupacion del vecindario, puede enviarlo en linea aqui.",
        noApplications: "No hay solicitudes registradas",
        noApplicationsBody:
          "Envíe una solicitud municipal de licencia en linea y aparecera aqui para seguimiento de estado y pago.",
      },
      labels: {
        license: "Licencia #{id}",
        request: "Solicitud #{id}",
        permit: "Permiso #{id}",
        reference: "Referencia #{id}",
        application: "Solicitud #{id}",
        permitApplication: "Solicitud de permiso #{id}",
        permitApplicationFields: {
          permit_type: "Tipo de permiso",
          contact_name: "Nombre del solicitante",
          email: "Correo electronico",
          phone: "Telefono",
        },
        municipalLicenseApplication: "Solicitud de licencia municipal",
        submittedLabel: "Enviada",
        type: "Tipo",
        fiscalYear: "Ano fiscal",
        issued: "Emitida",
        expires: "Vence",
        recordCreated: "Registro creado",
        submitted: "Enviado {value}",
        lastUpdated: "Ultima actualizacion {value}",
        noRequestDescription: "No se incluyo una descripcion con este envio.",
        issuedAsPermit: "Emitido como permiso {permit}.{suffix}",
        startApplication: "Comenzar solicitud",
        startPermitRequest: "Comenzar solicitud de permiso",
        reportConcern: "Reportar un problema",
        noExpirationDate: "Sin fecha de vencimiento",
        notIssuedYet: "Aun no emitida",
        municipalPermit: "Permiso municipal",
        pending: "pendiente",
      },
    },
    myApplications: {
      title: "Mis solicitudes",
      description: "Consulte el estado de sus solicitudes municipales de licencia.",
      newApplication: "Nueva solicitud",
      emptyTitle: "Todavia no hay solicitudes",
      emptyBody:
        "Cuando envíe una solicitud de licencia, aparecera aqui para que pueda seguir su progreso.",
      startFirst: "Comenzar su primera solicitud",
      submittedOn: "Enviada el {value}",
      inspectionScheduledFor: "Inspeccion programada para {value}",
      messageFromStaff: "Mensaje del personal",
      fee: "Cargo",
      applicant: "Solicitante",
      currentStatus: "Estado actual",
      nextAction: "Proximo paso",
      lastUpdate: "Ultima actualizacion",
      workflow: {
        states: {
          awaitingReview: "Pendiente de revision por el personal.",
          underReview: "El personal esta revisando su solicitud.",
          revisionRequired: "Se requieren cambios antes de continuar la revision.",
          denied: "Esta solicitud fue denegada y esta cerrada para cambios y reenvios.",
          billingPreparation: "Revision completa — se esta preparando la facturacion.",
          paymentDue: "El pago esta pendiente.",
          awaitingInspection: "Pago recibido — pendiente de programar la inspeccion.",
          inspectionScheduled: "Su inspeccion esta programada.",
          inspectionInProgress: "Su inspeccion esta en curso.",
          inspectionUnderReview: "Los resultados de su inspeccion estan en revision.",
          inspectionIssues: "La inspeccion encontro problemas que deben resolverse.",
          awaitingLicense: "Requisitos completos — el personal esta realizando la revision final.",
          awaitingDelivery: "Su licencia espera la aprobacion final del personal.",
          complete: "Su licencia esta aprobada y disponible para descargar.",
        },
        actions: {
          none: "No necesita hacer nada en este momento.",
          reviseAndResubmit: "Revise las instrucciones del personal, actualice su solicitud y vuelva a enviarla.",
          contactOffice: "Revise la decision y comuniquese con nuestra oficina si tiene preguntas.",
          submitPayment: "Abra su factura y envie el pago.",
          prepareForInspection: "Este disponible a la hora programada y siga las instrucciones del personal.",
          reviewInspectionInstructions: "Revise los resultados de la inspeccion y siga las instrucciones del personal.",
          downloadLicense: "Abra el registro de su licencia para descargar una copia. El envio por correo es opcional.",
        },
      },
      activities: {
        reviewed: "Revisada {value}",
        paymentRequested: "Pago solicitado {value}",
        paymentReceived: "Pago recibido {value}",
        inspectionScheduled: "Inspeccion programada {value}",
      },
      additionalDetails: "Detalles adicionales",
      showAllDetails: "Ver todos los detalles",
      hideAllDetails: "Ocultar detalles adicionales",
      detailGroups: {
        applicant: "Solicitante",
        business: "Negocio",
        property: "Propiedad y titularidad",
        owners: "Propietarios del negocio",
        contacts: "Contactos",
        fees: "Cargos",
        attestations: "Firma y declaracion",
        other: "Otros detalles",
      },
      quickbooksInvoiceIssued: "Factura de QuickBooks {value}",
      quickbooksInvoiceIssuedFallback: "Factura de QuickBooks emitida",
      viewInvoice: "Ver factura / estado del pago",
      proceedToPayment: "Continuar al pago",
      openInvoice: "Abrir factura de QuickBooks",
      viewPaymentInstructions: "Ver instrucciones de pago",
      awaitInvoice: "Revisar estado del pago",
      quickbooksPaymentHelp:
        "Abra su factura de QuickBooks para pagar. El personal marcara esta solicitud como pagada despues de recibir el pago.",
      quickbooksPaymentPendingHelp:
        "El personal enviara su enlace de factura de QuickBooks por los mensajes de la solicitud cuando este listo.",
      openLicense: "Abrir y descargar licencia",
      downloadConditionalLicense: "Descargar licencia condicional",
      preparingDownload: "Preparando descarga...",
    },
    payment: {
      title: "Instrucciones de pago de la solicitud",
      quickbooksDescription: "Use la factura de QuickBooks para pagar y vuelva aqui para revisar el estado.",
      standardDescription: "El personal enviara un enlace de factura de QuickBooks para esta solicitud.",
      refreshSuccess: "Se actualizo el estado del pago.",
      paymentRecorded: "El pago se registro correctamente.",
      application: "Solicitud",
      status: "Estado",
      licenseType: "Tipo de licencia",
      amountDue: "Monto adeudado",
      applicant: "Solicitante",
      submitted: "Enviado",
      quickbooksInvoice: "Factura de QuickBooks",
      quickbooksSync: "Sincronizacion de QuickBooks",
      issued: "Emitida",
      pending: "Pendiente",
      alreadyPaid: "Esta solicitud ya fue marcada como pagada el {value}.",
      quickbooksBody:
        "Esta factura se administra mediante QuickBooks Online. Use el enlace de factura de QuickBooks enviado por el personal para completar el pago.",
      quickbooksStepOne: "1. Abra el enlace de la factura de QuickBooks proporcionado por el personal.",
      quickbooksStepTwo: "2. Complete el pago a traves de QuickBooks Online.",
      quickbooksStepThree: "3. El personal marcara su solicitud como pagada en CodeSoft despues de recibir el pago.",
      quickbooksLinkPending:
        "Su solicitud esta esperando un enlace de factura de QuickBooks. Revise los mensajes de su solicitud o comuniquese con el personal si todavia no lo ve.",
      invoicePendingBody:
        "El pago de esta solicitud se maneja mediante una factura de QuickBooks emitida por el personal. Revise los mensajes de su solicitud para ver el enlace de la factura. El personal marcara la solicitud como pagada despues de recibir el pago.",
      openQuickbooksInvoice: "Abrir factura de QuickBooks",
      refreshPaymentStatus: "Actualizar estado del pago",
      refreshingPaymentStatus: "Actualizando...",
      confirmPayment: "Confirmar pago",
      processingPayment: "Procesando pago...",
      returnPortal: "Volver al portal publico",
    },
    helpWidget: {
      openLabel: "Ayuda y preguntas",
      title: "Centro de ayuda",
      subtitle: "Haga una pregunta o envie un mensaje al personal municipal.",
      tabAssistant: "Hacer una pregunta",
      tabStaff: "Contactar al personal",
      assistantGreeting:
        "Hola! Puedo ayudar con permisos, licencias, reglas del codigo municipal y a navegar este portal. Que le gustaria saber?",
      assistantDisclaimer: "Orientacion generada por IA, no es asesoria legal. Las decisiones del personal municipal son definitivas.",
      assistantPlaceholder: "Pregunte sobre permisos, licencias, codigo municipal...",
      assistantSend: "Enviar mensaje",
      assistantThinking: "Pensando...",
      newConversation: "Nueva conversacion",
      wasHelpful: "Le resulto util?",
      talkToStaff: "Hablar con el personal",
      feedbackThanks: "Gracias por su comentario!",
      errorDisabled: "El asistente no esta disponible en este momento. Por favor contacte al personal.",
      errorRateLimit: "Esta enviando mensajes demasiado rapido. Espere unos minutos e intente de nuevo.",
      errorTimeout: "El asistente tardo demasiado en responder. Intente de nuevo.",
      errorGeneric: "Lo sentimos, algo salio mal. Intente de nuevo en un momento.",
      turnstileHint: "Complete la verificacion rapida a continuacion para comenzar a chatear.",
      anonStaffIntro: "Para enviar mensajes al personal municipal y dar seguimiento a sus solicitudes, inicie sesion o cree una cuenta gratuita.",
      anonConcernHint: "Quiere reportar un problema en una propiedad? No necesita una cuenta:",
      anonConcernLink: "Reportar un problema",
      anonSignIn: "Iniciar sesion",
      anonRegister: "Crear cuenta",
      loadingOptions: "Cargando opciones de ayuda...",
      choicePrompt: "Este mensaje es sobre una de sus solicitudes?",
      chooseApplication: "Si, elegir una solicitud",
      generalHelp: "No, necesito ayuda general",
      selectApplication: "Seleccione la solicitud",
      messageLabel: "Su mensaje",
      describeHelpPlaceholder: "Describa en que necesita ayuda...",
      sendToApplicationStaff: "Enviar al personal de la solicitud",
      sending: "Enviando...",
      generalPrompt: "En que necesita ayuda?",
      generalPlaceholder: "Describa el problema. El personal vera en que pagina del portal estaba.",
      sendHelpRequest: "Enviar solicitud de ayuda",
      viewRecentThread: "Ver su conversacion de soporte reciente",
      startThreadIntro: "Inicie una solicitud de soporte general y el personal respondera aqui.",
      startRequest: "Iniciar solicitud",
      noMessages: "Aun no hay mensajes.",
      replyPlaceholder: "Escriba su respuesta...",
      sendReply: "Enviar respuesta",
      you: "Usted",
      staff: "Personal",
      messageSent: "Su mensaje fue enviado al personal de esa solicitud.",
      requestSent: "Su solicitud fue enviada al personal.",
      errorLoad: "No se pudieron cargar las opciones de ayuda.",
      errorSendMessage: "No se pudo enviar su mensaje.",
      errorSendRequest: "No se pudo enviar su solicitud.",
      errorSendReply: "No se pudo enviar su respuesta.",
    },
    pageTitles: {
      landing: "Inicio",
      residentConcern: "Reportar un problema",
      applyLicense: "Solicitud de licencia comercial",
      applyPermit: "Solicitud de permiso",
      payment: "Pago de solicitud",
      verifyLicense: "Verificar una licencia",
      publicLogin: "Acceso para residentes",
      register: "Crear una cuenta",
      staffLogin: "Acceso para personal",
      forgotPassword: "Olvido su contrasena",
      resetPassword: "Restablecer contrasena",
      myApplications: "Mis solicitudes",
      publicDashboard: "Panel de residentes",
    },
  },
};
